exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"radio\"] { /* IE 9 */ /* Chrome, Safari, Opera */\n    transform: scale(1.2);\n}\n\n.powered-by{\n    width:200px;\n    margin:10px 27px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/cart/cart.component.css
// module id = ../../../../../src/app/cart/cart.component.css
// module chunks = main